module.exports = __webpack_public_path__ + "static/media/img-lessons.141d0555.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/img-lessons.png
// module id = 589
// module chunks = 0